import { render, staticRenderFns } from "./TSimple.vue?vue&type=template&id=be181d56&scoped=true&"
import script from "./TSimple.vue?vue&type=script&lang=js&"
export * from "./TSimple.vue?vue&type=script&lang=js&"
import style0 from "./TSimple.vue?vue&type=style&index=0&id=be181d56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be181d56",
  null
  
)

export default component.exports